import React from "react";

const ReversalIcon = ({ size, className, ...inputProps }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size ?? '24'} height={size ?? '24'} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-undo2 w-4 h-4"><path d="M9 14 4 9l5-5"></path><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11"></path></svg>
    );
};

export default ReversalIcon;
